import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LeadsActions from '../LeadsActions';

import './LeadsEmptyState.styles.scss';
import './LeadsEmptyState.styles.responsive.scss';

type LeadsEmptyStateProps = {
  className?: string;
};

const LeadsEmptyState: React.FC<LeadsEmptyStateProps> = (props) => {
  const { className } = props;

  const classes = classNames('leads-empty-state', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{t('noLeadsFound')}</p>
      <p>{t('noLeadsFoundMessage')}</p>

      <LeadsActions />
    </div>
  );
};

export default LeadsEmptyState;
